import {
  RequestCreationView, IncidentCreationView, FormView, SuggestionsAndCommentsView,
} from '@/views';
// import store from '@/store';
import { TYPE } from '@/store/modules/catalog';
import constants from '@/plugins/vue-constants/constants';

/* const migrationFormsAccessChecking = (redirect) => function beforeEnter(to, from, next) {
  const sessionContact = store.getters['session/user'];
  if (process.env.NODE_ENV === 'production' && sessionContact != null
    && !sessionContact.formsMigrationGroupMember) {
    next(redirect);
  } else {
    next();
  }
}; */

const routes = {
  privatePaths: [
    {
      path: '/request/:category?',
      component: RequestCreationView,
      props: ({ params, query }) => {
        const { bookmarks, search } = query;
        let searchtext;
        if (typeof search === 'string' && search.trim() !== '') {
          searchtext = search.trim();
        }
        return ({
          category: params.category,
          ticketType: TYPE.REQUEST,
          bookmarks: bookmarks === 'true',
          searchtext,
        });
      },
    },
    {
      path: '/request/:categoryParent/subcatalog/:category',
      component: RequestCreationView,
      props: ({ params, query }) => {
        const { bookmarks, search } = query;
        let searchtext;
        if (typeof search === 'string' && search.trim() !== '') {
          searchtext = search.trim();
        }
        return ({
          category: params.category,
          categoryParent: params.categoryParent,
          ticketType: TYPE.REQUEST,
          bookmarks: bookmarks === 'true',
          searchtext,
        });
      },
    },
    {
      path: 'element/:type/:element',
      component: FormView,
      props: ({ params, query }) => {
        const type = Object.entries(TYPE)
          .find((entry) => entry[1].toLowerCase() === (params.type || '').toLowerCase());
        return {
          elementId: params.element,
          ticketType: type != null ? type[1] : null,
          queryParams: query,
        };
      },
    },
    {
      path: '/element/:type/:element',
      name: 'formGeneric',
      component: FormView,
      props: ({ params, query }) => {
        const type = Object.entries(TYPE)
          .find((entry) => entry[1].toLowerCase() === (params.type || '').toLowerCase());
        return {
          elementId: params.element,
          ticketType: type != null ? type[1] : null,
          queryParams: query,
        };
      },
    },
    {
      path: '/request/:category/:element',
      alias: ['/element/r/:element'],
      name: 'formGeneric',
      component: FormView,
      props: ({ params, query }) => ({
        categoryId: params.category,
        elementId: params.element,
        ticketType: TYPE.REQUEST,
        queryParams: query,
      }),
    },
    {
      path: '/request/:categoryParent/subcatalog/:category/:element',
      alias: ['/element/r/:element'],
      name: 'formGeneric',
      component: FormView,
      props: ({ params, query }) => ({
        categoryId: params.category,
        categoryParent: params.categoryParent,
        elementId: params.element,
        ticketType: TYPE.REQUEST,
        queryParams: query,
      }),
    },
    {
      path: '/request/:element/clone/:idTicket',
      component: FormView,
      props: ({ params }) => ({
        elementId: params.element,
        ticketType: TYPE.REQUEST,
        idTicket: Number(params.idTicket),
        method: 'clone',
      }),
    },
    {
      path: '/incident',
      component: IncidentCreationView,
      props: ({ query }) => {
        const { bookmarks, search } = query;
        let searchtext;
        if (typeof search === 'string' && search.trim() !== '') {
          searchtext = search.trim();
        }
        return ({
          ticketType: TYPE.INCIDENT,
          bookmarks: bookmarks === 'true',
          searchtext,
        });
      },
    },
    {
      path: '/incident/:category/:element',
      component: FormView,
      props: ({ params }) => ({
        categoryId: params.category,
        elementId: params.element,
        ticketType: TYPE.INCIDENT,
      }),
    },
    {
      path: '/incident/:element/clone/:idTicket',
      component: FormView,
      props: ({ params }) => ({
        elementId: params.element,
        ticketType: TYPE.INCIDENT,
        idTicket: Number(params.idTicket),
        method: 'clone',
      }),
    },
    {
      path: '/problem',
      component: FormView,
      props: () => ({
        elementId: constants.problem.idProblem,
        ticketType: TYPE.PROBLEM,
      }),
    },
    {
      path: '/suggestion',
      component: SuggestionsAndCommentsView,
      props: () => ({
        elementId: constants.suggestion.idSuggestion,
        ticketType: TYPE.REQUEST,
        hideViewTitle: true,
      }),
    },
  ],
  publicPaths: [],
};

export default routes;
